import React from 'react';
import IHSForecastCatalog from './IHSForecastCatalog';

const IHSCarlineBrowser = ({ opportunityId, onLink, onClose, onCreateOpportunity }) => (
  <IHSForecastCatalog
    mode="modal"
    opportunityId={opportunityId}
    onLink={onLink}
    onClose={onClose}
    onCreateOpportunity={onCreateOpportunity}
    allowLink={Boolean(opportunityId)}
    allowCreateOpportunity={!opportunityId}
    title="IHS Market Data Browser"
    subtitle={opportunityId ? 'Search and link carlines to this opportunity' : 'Browse vehicle carlines from the market forecast'}
  />
);

export default IHSCarlineBrowser;
